<template>
  <div class="autocomplete w-full">
      <div ref="result"></div>
      <input @input="textChanged"
             @change="textOnChange"
             :class="classes ? classes : 'al-input'"
             type="text" placeholder="Full address" v-model="localLocation"
             v-validate="'required'"
             name="Address">
    <ul class="autocomplete-items">
      <li class="prediction" v-for="(result, i) in searchResults" :key="i" @click="setValue(result)">
        {{ result.description }}
      </li>
    </ul>
  </div>
</template>
<script>
export default {
  props: {
    found: {
      type: Function
    },
    location: {
      type: String
    },
    classes: {
      type: String
    }
  },
  name: 'Places',
  data: () => ({
    searchResults: [],
    service: null, // will reveal this later 🕵️,
    placeService: null,
    address: null,
    search_break: false,
    selectedPlace: null,
    localLocation: '',
    init: true
  }),
  watch: {
    localLocation (newValue) {
      if (newValue && !this.search_break && !this.init) {
        this.service.getPlacePredictions({
          input: this.localLocation,
          fields: ['address_components', 'geometry'],
          types: ['address']
        }, this.displaySuggestions)
      }
      if (newValue === '') {
        this.searchResults = []
      }
    }
  },
  methods: {
    textChanged (e) {
      console.log('t changed', e.target.value)
      this.init = false
    },
    textOnChange () {
      if (this.localLocation === '') {
        this.init = true
        this.localLocation = this.location
      }
    },
    setValue (value) {
      this.searchResults = []
      this.search_break = true
      setTimeout(() => {
        this.search_break = false
      }, 3000)
      this.localLocation = value.structured_formatting.main_text
      this.address = {
        place_id: value.place_id
      }
      this.getPlaceDetails(value.place_id, (PlaceResult) => {
        console.log('selected palce detail', PlaceResult)
        let adress_result = ''
        PlaceResult.address_components.filter(component => {
          if (component.types.includes('street_number')) {
            adress_result = component.long_name
            this.address.no = adress_result
          }
          if (component.types.includes('route')) {
            adress_result = component.long_name
            this.address.street = adress_result
          }
          if (component.types.includes('sublocality') || component.types.includes('sublocality_level_1')) {
            adress_result = component.long_name
            this.address.city = adress_result
          }
          if (component.types.includes('administrative_area_level_1')) {
            adress_result = component.short_name
            this.address.state = adress_result
          }
          if (component.types.includes('postal_code')) {
            adress_result = component.short_name
            this.address.zipcode = adress_result
          }
        })
        if (typeof this.address.city === 'undefined') {
          PlaceResult.address_components.filter(component => {
            if (component.types.includes('locality')) {
              this.address.city = component.long_name
            }
          })
        }
        const reslocation = {
          type: 'Point',
          coordinates: [PlaceResult.geometry.location.lat(), PlaceResult.geometry.location.lng()]
        }
        console.log('location selected', this.location)

        this.found(this.address, reslocation)
      })
    },
    MapsInit () {
      this.placeService = new window.google.maps.places.PlacesService(this.$refs.result)
      this.service = new window.google.maps.places.AutocompleteService()
      console.log('service', this.service)
    },
    getPlaceDetails (place_id, callback) {
      const self = this
      this.placeService.getDetails({placeId: place_id}, function (PlaceResult, PlacesServiceStatus) {
        // PlaceResult is an object
        // PlacesServiceStatus is a string
        self.selectedPlace = PlaceResult
        console.log('places service status', PlacesServiceStatus)
        callback(PlaceResult)
      })
    },
    displaySuggestions (predictions, status) {
      if (status !== window.google.maps.places.PlacesServiceStatus.OK) {
        this.searchResults = []
        console.log(status, predictions)
        return
      }
      this.searchResults = predictions.map(prediction => prediction)

    }
  },
  beforeCreate () {
  },
  mounted () {
    this.MapsInit()
    console.log('local loc', this.localLocation)
    setTimeout(() => {
      this.localLocation = this.location
    }, 500)
  }
}
</script>

<style lang="scss">
.autocomplete-items {
  position: absolute;
  border: 1px solid #d4d4d4;
  border-bottom: none;
  border-top: none;
  z-index: 99;
  /*position the autocomplete items to be the same width as the container:*/
  top: 100%;
  left: 0;
  right: 0;
  background: white;

}
.autocomplete-items li {
  padding: 10px;
  cursor: pointer;
  background-color: #fff;
  border-bottom: 1px solid #c3c3c3;
}
.autocomplete-items li:hover {
  /*when hovering an item:*/
  background-color: #e9e9e9;
}
.autocomplete-active {
  /*when navigating through the items using the arrow keys:*/
  background-color: DodgerBlue !important;
  color: #ffffff;
}
.autocomplete {
  /*the container must be positioned relative:*/
  position: relative;
  display: inline-block;

  input {
    margin-bottom: 0 !important;
  }

}
</style>
